import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRODUCTS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const patchProductAction = createAsyncThunk(
    'product/patchProductAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ PRODUCTS_PATH }/${ data.id }`, { command: data.command });
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const patchProductSlice = createSlice({
    name: 'patchProductSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(patchProductAction.pending, () => STATE__API__STARTED);
        builder.addCase(patchProductAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(patchProductAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const patchProductState = (state) => state.product.patchProduct;
export default patchProductSlice.reducer;